"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * DO NOT MODIFY
 * This file is generated by StashInvest/product-events
 * To open an issue, go to https://github.com/StashInvest/product-events/issues/new/choose
 */

class Event {
  constructor(object, action, version, properties = null) {
    this.object = object;
    this.action = action;
    this.version = version;
    this.properties = properties;
  }
  track() {
    try {
      const eventName = `${this.object}_${this.action}`;
      const topicName = `product.events.${this.object.toLowerCase()}_${this.action.toLowerCase()}.${this.version.toLowerCase()}`;
      if (!this.properties) {
        return {
          eventName,
          topicName
        };
      }
      const propertiesMap = this.propertiesToMap(this.properties);
      return {
        eventName,
        topicName,
        propertiesMap
      };
    } catch (error) {
      console.error(`Validation failed: ${error.message}`);
    }
  }
  propertiesToMap(properties) {
    return properties.toJSON ? properties.toJSON() : {};
  }
}
var _default = exports.default = Event;
//# sourceMappingURL=event.js.map